import { System } from "nopun-ecs";
import { Polygon } from "detect-collisions";

import { CollisionShape, Position2D, Velocity2D } from "../component";
import { Asteroid, Bullet, addExplosionToScene, Player, breakAsteroid } from "../entity";
import { Score } from "../resource";

export class CollisionSystem extends System {
    static queries = {
        withPosition: [CollisionShape, Position2D],
        withVelocity: [CollisionShape, Velocity2D],
        player: [CollisionShape, Player],
        bullets: [CollisionShape, Bullet],
        asteroids: [CollisionShape, Asteroid]
    };

    execute() {
        for (const entity of this.queries.withPosition.all) {
            const position = entity.get(Position2D);
            const collisionShape = entity.get(CollisionShape);

            collisionShape.body.x = position.x;
            collisionShape.body.y = position.y;
        }

        for (const entity of this.queries.withVelocity.all) {
            const collisionShape = entity.get(CollisionShape);

            if (collisionShape.body instanceof Polygon) {
                const {angle} = entity.get(Velocity2D);

                collisionShape.body.angle = (angle / 180) * Math.PI;
            }
        }

        const score = this.scene.resources.get(Score);
        asteroidCollisions: for (const asteroid of this.queries.asteroids.all) {
            for (const player of this.queries.player.all) {
                if (asteroid.get(CollisionShape).body.collides(player.get(CollisionShape).body)) {
                    const position = player.get(Position2D);
                    const { angle, speed } = player.get(Velocity2D);

                    this.scene.entities.destroy(player);

                    addExplosionToScene(this.scene)
                        .add(Position2D, { ...position })
                        .add(Velocity2D, { angle, speed });

                    breakAsteroid(asteroid);

                    continue asteroidCollisions;
                }
            }

            for (const bullet of this.queries.bullets.all) {
                if (asteroid.get(CollisionShape).body.collides(bullet.get(CollisionShape).body)) {
                    const {speed} = asteroid.get(Velocity2D);
                    const {size} = asteroid.get(Asteroid);

                    this.scene.entities.destroy(bullet);

                    score.value += Math.round(size.points * speed);

                    breakAsteroid(asteroid);

                    continue asteroidCollisions;
                }
            }
        }
    }
}